
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Form, Popover, Popconfirm, message } from 'antd';
import FormInputControl from './FormInputControl.js';
import ModalWrap from './modal.js'
import SvgIcon from '@mdf/metaui-web/lib/components/common/SvgIcon';

process.env.__CLIENT__ && require('./index.less');

const FormItem = Form.Item;
// test
const propTypes = {
  className: PropTypes.string,
  status: PropTypes.string,
  onOk: PropTypes.func,//确定按钮钩子函数
  onCancel: PropTypes.func,//取消按钮钩子函数
  locale: PropTypes.string.isRequired, //当前语种
  localeList: PropTypes.object.isRequired, //语种数组
  onChange: PropTypes.func, //文本框改变回掉
  isTextarea: PropTypes.bool, // 是否textarea 默认false
  modalLocale: PropTypes.object,
  backdrop: PropTypes.bool,  //是否弹出遮罩层/遮罩层点击是否触发关闭
  required: PropTypes.bool, // 是否要求当前语种和系统语种必填
  isPopConfirm: PropTypes.bool, // 录入时是否是popconfirm,还是modal的样式
  showIcon: PropTypes.bool
}

const defaultProps = {
  classnames: '',
  status: 'preview',
  isTextarea: false,
  backdrop: true,
  required: false,
  isPopConfirm: false,
  showIcon: true
}

const AC_DEFAULT_SYSLOCALE = 'zh_CN';
const AC_DEFAULT_LOCALE = 'zh_CN';
const AC_DEFAULT_LOCALELIST = {
  "zh_CN": "",
  "en_US": "",
  "zh_TW": "",
  "fr_FR": ""
  // "de_DE": "德语",
  // "ja_JP": "日语",
  // "ko_KR": "韩语",
  // "ru_RU": "俄语",
  // "it_IT": "意大利语",
  // "pt_PT": "葡萄牙语"
}

const getContent = (localeList, modalLocale, locale) => {
  return Object.keys(localeList).map(localeKey => (
    <Row key={'preview' + localeKey} className='input-locale-text'>
      <div className='input-locale-text-r'>
        {
          modalLocale['label'][localeKey]
        }:
          </div>
      <div className="input-locale-text-l">
        {
          localeList[localeKey]
        }
      </div>
    </Row>
  ))
}

class AcInputLocale extends Component {
  constructor(props) {
    super(props);
    let { locale, localeList, status, modalLocale, sysLocale, required, isPopConfirm, focus } = props;

    //组件内默认值
    sysLocale = sysLocale || AC_DEFAULT_SYSLOCALE;
    locale = locale || sysLocale;
    if (localeList) {
      localeList = { ...this.getDefaultLocalList(), ...localeList };
    } else {
      localeList = { ...this.getDefaultLocalList() };
    }



    let localeValue = localeList[locale];

    let modalLocaleTmp = Object.assign({}, {
        'title': '多语言设置',
        'okName': '保存',
        'cancelName': '取消',
        'localeFlag': '当前',
        'defaultFlag': '默认',
        'placeholder': '请输入...',
        'errorMsg': '不能为空',
        'currentLang': '当前语种',
        'defaultLang': '默认语种',
        'label': {
          "zh_CN": "简体中文",
          "en_US": "英文",
          "zh_TW": "繁体中文",
          "fr_FR": "法语",
          "de_DE": "德语",
          "ja_JP": "日语",
          "ko_KR": "韩语",
          "ru_RU": "俄语",
          "it_IT": "意大利语",
          "pt_PT": "葡萄牙语"
        }
    }, modalLocale)
    this.state = {
      localeList: JSON.parse(JSON.stringify(localeList)),
      _localeList: JSON.parse(JSON.stringify(localeList)),
      localeValue,
      sysLocale,
      locale,
      status,
      required,
      showModal: false,
      showPop: false,
      isPopConfirm,
      modalLocale: modalLocaleTmp,
      focused: this.props.focus ? true : false,
      gct: { a: 1, b: 'test' }
    }

    this.isMouseEnterIcon = false;//用于标识当前是否处于icon的预打开或打开状态

    this.onClose = this.onClose.bind(this);
    this.open = this.open.bind(this);
    this.onOk = this.onOk.bind(this);
    this.onCancel = this.onCancel.bind(this);

    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);

    this.onMouseEnterIcon = this.onMouseEnterIcon.bind(this);
    this.onMouseLeaveIcon = this.onMouseLeaveIcon.bind(this);


  }
  componentDidMount() {
    // if (this.props.focus) {
    //   if (this.textInput && this.textInput._input) {
    //     this.textInput.input.focus();
    //   }
    // }

  }
  componentWillReceiveProps(nextProps) {
    // 语种列表改变，localeValue也要改变
    // 这里的判断是 对象，判断的是对象引用地址是否一样
    if (this.props.localeList !== nextProps.localeList) {
      let { locale, localeList } = nextProps;

      //当prop不合法时的处理
      locale = locale || this.state.sysLocale;
      if (localeList) {
        localeList = { ...this.getDefaultLocalList(), ...localeList };
      } else {
        localeList = { ...this.getDefaultLocalList() };
      }



      let localeValue = localeList[locale];
      this.setState({
        localeList,
        _localeList: JSON.parse(JSON.stringify(localeList)),
        localeValue,
        locale
      })
    }

    // 只改变语种，不改变语种列表
    if (nextProps.locale !== this.props.locale && nextProps.localeList === this.props.localeList) {
      let { locale, sysLocale } = nextProps;

      if (!locale) {
        locale = sysLocale || 'zh_CN'
      }

      let localeValue = '';
      Object.keys(nextProps.localeList).forEach((localeKey) => {
        if (localeKey === locale) {
          localeValue = nextProps.localeList[localeKey]
        }
      })
      this.setState({
        locale,
        localeValue
      })
    }
    // 改变状态
    if (nextProps.status !== this.props.status) {
      this.setState({
        status: nextProps.status
      })
    }
  }

  getDefaultLocalList() {
    return AC_DEFAULT_LOCALELIST;
  }
  onMouseEnterIcon = () => { this.isMouseEnterIcon = true; }
  onMouseLeaveIcon = () => { this.isMouseEnterIcon = false; }

  onClose = () => {
    const { isPopConfirm } = this.state;
    this.isMouseEnterIcon = false;
    this.state.isPopConfirm ? this.setState({ showPop: false, focused: true }) : this.setState({ showModal: false, focused: true });
  }

  open = (event) => {
    event.stopPropagation();
    let { status, localeList } = this.props;
    if (status === 'preview') {
      return
    }
    this.isMouseEnterIcon = true;
    this.state.isPopConfirm ? this.setState({ showPop: true, focused: false }) : this.setState({ showModal: true, focused: false });
  }

  onOk = () => {
    const { localeList, _localeList, locale, required } = this.state


    //let localeListProps = this.props.localeList;
    let { inputId } = this.props;

    let validatedArray = [];
    let fireChange = false;
    Object.keys(_localeList).forEach((localeKey) => {
      //同步_localeList -> localeList
      validatedArray.push(inputId + "_" + localeKey);
      if (localeList[localeKey] != _localeList[localeKey]) {
        localeList[localeKey] = _localeList[localeKey];
        fireChange = true;
      }
    })

    fireChange && this.onChange(_localeList[locale], _localeList);

    // 如果有form表单，就校验，否则就不校验
    if (required) {
      let obj = {};
      obj[this.props.inputId] = _localeList[locale];
      this.props.form.validateFields(validatedArray, (err, values) => {
        if (err) {
          console.log('validate failed', values);
          return;
        } else {
          this.props.form.setFieldsValue(obj)
          this.props.onOk && this.props.onOk(_localeList);
          this.onClose()
        }
      });
    } else {
      this.props.onOk && this.props.onOk(_localeList);
      this.onClose()
    }

    // this.setState({ localeList });
  }

  onCancel = () => {
    let _localeList = JSON.parse(JSON.stringify(this.state.localeList));
    //this.state._localeList = _localeList;
    this.setState({ _localeList });

    this.onClose();
  }

  stringTrim = (str) => {
    return str.replace(/^\s+|\s+$/gm, '');
  }

  //校验处理
  checkValidValue = (rule, value, callback) => {
    let self = this;
    let { required, localeList, locale, sysLocale } = self.state;
    let currentLanguage = self.state.modalLocale ? self.state.modalLocale.currentLang : "当前语种";
    let defaultLanguage = self.state.modalLocale ? self.state.modalLocale.defaultLang : "默认语种";
    let errMessage = self.state.modalLocale ? self.state.modalLocale.errorMsg : "不能为空";
    if (required) {
      if (!self.stringTrim(localeList[locale])) {
        callback(currentLanguage + " " + errMessage)
      }
      if (!self.stringTrim(localeList[sysLocale])) {
        callback(defaultLanguage + " " + errMessage);
      }
    }
    callback();
  }

  //label左侧的渲染
  renderLabelLeft = (localeKey) => {
    let { localeValue, locale, localeList, status, modalLocale, sysLocale } = this.state
    if (locale === sysLocale) {
      if (localeKey === locale) {
        return <span className="label-default">({modalLocale.localeFlag + "/" + modalLocale.defaultFlag})</span>
      }
    } else {
      if (localeKey === locale) {
        return <span className="label-default">({modalLocale.localeFlag})</span>
      }
      if (localeKey === sysLocale) {
        return <span className="label-default">({modalLocale.defaultFlag})</span>
      }
    }
  }
  renderLabelright = (localeKey) => {
    let { localeValue, locale, localeList, status, modalLocale, sysLocale, required } = this.state
    if (required) {
      if (locale == sysLocale) {
        if (localeKey == locale) {
          return <span className="require-star uf uf-mi" > *</span>
        }
      } else {
        if (localeKey == locale || localeKey == sysLocale) {
          return <span className="require-star uf uf-mi"> *</span>
        }
      }
    }

    return <span className="require-star" ></span>

  }

  getPreviewElement(localeValue, defaultValue, localeList, modalLocale, locale) {
    return (
      <div>
        <FormInputControl
          readOnly={true}
          value={
            localeValue || defaultValue
          }
        />
        {/* <span className="view-title-content">
              {localeValue || defaultValue}
            </span>           */}
        {
          this.props.showIcon ?
            <Popover
              placement="right"
              content={getContent(localeList, modalLocale, locale)}
              trigger="hover"
              id="right"
            >
              <i className="uf uf-globe input-icon" />
            </Popover>
            : ''
        }
      </div>
    )
  }

  getLocaleNoFormElement(localeList, modalLocale, locale) {
    return Object.keys(localeList).map((localeKey) => {
      return (<div className='edit-panel edit-panel-all' key={localeKey}>
        <FormItem>
          <div className="u-form-item-label">
            <label className="u-label" title={modalLocale['label'][localeKey]}>
              {this.isShowNoneLeftLable ? this.renderLabelLeft(localeKey) : null}
              {modalLocale['label'][localeKey]}
              {this.renderLabelright(localeKey)}
            </label>
          </div>
          <div style={{ 'display': 'inline-block', 'width': 'calc(100% - 150px)' }}>
            <FormInputControl value={localeList[localeKey]} placeholder={modalLocale.placeholder}
              onChange={(v) => {
                let _localeList = this.state._localeList;
                _localeList[localeKey] = v
                this.setState({
                  _localeList
                })
              }}
            />
          </div>
        </FormItem>
      </div>)
    })
  }
  forceSyncChange = (localeList, value) => {
    let { inputId, form } = this.props;
    Object.keys(localeList).forEach(item => {
      localeList[item] = value;
      if (form) {
        let { setFieldsValue } = form;
        let key = `${inputId}_${item}`;
        let obj = {};
        obj[key] = value;
        setFieldsValue(obj)
      }

    })
    return localeList;
  }
  getLocaleFormElement(localeList, modalLocale, locale, sysLocale, getFieldProps, getFieldError) {
    return Object.keys(localeList).map((localeKey) => {
      return (<div className='edit-panel edit-panel-all' key={localeKey}>
        <FormItem>
          <div className="u-form-item-label">
            <label className="u-label" title={modalLocale['label'][localeKey]}>
              {
                this.isShowNoneLeftLable ? this.renderLabelLeft(localeKey) : null
              }
              {modalLocale['label'][localeKey]}
              {
                this.renderLabelright(localeKey)
              }
            </label>
          </div>
          <div style={{ 'display': 'inline-block', 'width': 'calc(100% - 150px)' }}>
            <div>
              <FormInputControl placeholder={modalLocale.placeholder}
                {...getFieldProps(this.props.inputId + "_" + localeKey, {
                  validateTrigger: 'onBlur',
                  // rules: [{
                  //   validator: this.checkValidValue
                  // }],
                  initialValue: localeList[localeKey],
                  getValueProps: (value) => { return { value: localeList[localeKey] } },
                  rules: [{
                    required: (localeKey == locale || localeKey == sysLocale) ? true : false,
                    message: modalLocale["errorMsg"],
                  }],
                  onChange: (v) => {
                    let _localeList = this.state._localeList;
                    _localeList[localeKey] = v
                    this.setState({
                      _localeList
                    })
                  }
                }
                )}
                onClick={(e) => { e.stopPropagation() }}
              />
              {this.props.showIcon ? <div className="input-icon" onClick={this.open} ></div> : ''}
              {
                //   getFieldError(this.props.inputId + "_" +localeKey)
                //   <span className='error uf uf-exc-t'>
                //     {getFieldError(this.props.inputId + "_" +localeKey)}
                //   </span>:''
              }

            </div>
          </div>
        </FormItem>
      </div>)
    })
  }

  equalLang(obj1, obj2) {
    const _equal = function (obj1, obj2) {
      try {
        for (const key in obj1) {
          if (obj1[key] != obj2[key]) {
            return false
          }
        }
      } catch (e) {
        return false;
      }
      return true;
    }
    return _equal(obj1, obj2) && _equal(obj2, obj1);
  }
  onChange(localeValue, localeList) {
    localeList[this.state.locale] = localeValue;
    if (this.props.forceSync) localeList = this.forceSyncChange(localeList, localeValue);
    this.props.onChange && this.props.onChange(localeValue, localeList);
    this.setState({ localeValue, localeList });
  }
  onBlur(localeValue, localeList) {
    localeList[this.state.locale] = localeValue;
    //if (this.props.forceSync) localeList = this.forceSyncChange(localeList, localeValue);    
    if (!this.isMouseEnterIcon) {
      this.props.onBlur && this.props.onBlur(localeValue, localeList);
      this.setState({ focused: false });
    }
  }
  onFocus(e) {
    const target = e.target;
    this.props.onFocus && this.props.onFocus();
    this.setState({ focused: true });
  }


  _renderModalInputLocal() {
    // this._renderModalRequireInputLocal();
    // return;
    const self = this;
    const { className, isTextarea, backdrop, disabled, forceSync, onChange, onBlur } = this.props;
    let { localeValue, locale, localeList, _localeList, status, modalLocale, sysLocale, required, isPopConfirm } = this.state;
    let defaultValue;
    if (localeList && localeList[sysLocale]) {
      defaultValue = localeList[sysLocale];
    }
    let formControlTypeOption = {}
    isTextarea ? formControlTypeOption = { componentClass: 'textarea' } : null
    let selfProps = {};
    if (this.state.focused) {
      selfProps['focus'] = true;//'focus'
    }
    let getFieldProps, getFieldError
    return (
      <div className={`ac-input-locale ${className ? className : null}`} >
        {
          status === 'preview' ? this.getPreviewElement(localeValue, defaultValue, localeList, modalLocale, locale) : (
            < div >
              <FormInputControl {...selfProps} className="input-text" value={localeValue}
                {...formControlTypeOption}
                onChange={(value) => {
                  localeList[locale] = value;
                  if (forceSync) localeList = self.forceSyncChange(localeList, value);
                  self.onChange && self.onChange(value, localeList);
                  if (!this.equalLang(localeList, this.state.localeList)) {
                    this.setState({ localeValue: value, localeList });
                  }
                }}
                onBlur={(value) => {
                  if (this.isMouseEnterIcon) return;
                  localeList[locale] = value;
                  if (forceSync) { localeList = self.forceSyncChange(localeList, value); }
                  self.onBlur && self.onBlur(value, localeList);
                  if (!this.equalLang(localeList, this.state.localeList)) {
                    this.setState({ localeValue: value, localeList });
                  }
                }}
                onFocus={e => self.onFocus(e)}
                onClick={(e) => { e.stopPropagation(); }}
                ref={(input) => { this.textInput = input; }}
              />
              {this.props.showIcon ? <div className="input-icon" onClick={disabled ? () => { } : this.open} onMouseEnter={this.onMouseEnterIcon} onMouseLeave={this.onMouseLeaveIcon} ><SvgIcon type={"yingwen"} /></div> : ''}
            </div>
          )
        }
        <ModalWrap title={modalLocale.title} showModal={this.state.showModal} backdrop={backdrop} cancelName={modalLocale.cancelName}
          onOk={this.onOk}
          onCancel={this.onCancel}
          okName={modalLocale.okName}
          close={this.onClose}
        >
          {
            this.getLocaleNoFormElement(_localeList, modalLocale, locale)

          }
        </ModalWrap>
      </div >
    )
  }
  _renderModalRequireInputLocal() {
    const self = this;
    const { className, isTextarea, backdrop, disabled, forceSync, onChange, onBlur } = this.props
    let { localeValue, locale, localeList, _localeList, status, modalLocale, sysLocale, required, isPopConfirm } = this.state
    let defaultValue;
    if (localeList && localeList[sysLocale]) {
      defaultValue = localeList[sysLocale];
    }
    let formControlTypeOption = {}
    isTextarea ? formControlTypeOption = { componentClass: 'textarea' } : null
    let selfProps = {};
    if (this.state.focused) {
      selfProps['focus'] = true;
    }
    // model弹窗校验数据加工
    // let errMessage = modalLocale ? modalLocale.errorMsg : "不能为空";
    // for(var item in modalLocale) {
    //   if(item == locale || item == sysLocale) {
    //     modalLocale[item]["required"] =  true;
    //     modalLocale[item]["errorMessage"] = modalLocale[item]["label"][item] + " " + errMessage
    //   } else {
    //     modalLocale[item]["required"] = false;
    //     modalLocale[item]["errorMessage"] = modalLocale[item]["label"][item] + " " + errMessage
    //   }
    // }
    let getFieldProps = this.props.form.getFieldProps
    let getFieldError = this.props.form.getFieldError


    return (
      <div className={`ac-input-locale ${className ? className : null}`} >
        {
          status === 'preview' ? this.getPreviewElement(localeValue, defaultValue, localeList, modalLocale, locale) : (
            <div>
              <FormInputControl {...selfProps} className="input-text" disabled={disabled}
                {...formControlTypeOption}
                {...getFieldProps(this.props.inputId, {
                  //   validateTrigger: 'onBlur',
                  //   rules: [{
                  //     validator: this.checkValidValue
                  //   }],
                  getValueProps: (value) => {
                    return {
                      value: localeValue
                    }
                  },
                  initialValue: localeValue,
                  // onChange: (value) => {
                  //   console.error('####2--onchange')
                  //   localeList[locale] = value;
                  //   if (forceSync) localeList = self.forceSyncChange(localeList, value);
                  //   self.onChange && self.onChange(value, localeList);
                  //   if (!this.equalLang(localeList, this.state.localeList)) {
                  //     console.error('@@@--onchange')
                  //     this.setState({ localeValue: value, localeList });
                  //   }
                  // }
                })}

                onChange={(value) => {
                  localeList[locale] = value;
                  if (forceSync) localeList = self.forceSyncChange(localeList, value);
                  self.onChange && self.onChange(value, localeList);
                  if (!this.equalLang(localeList, this.state.localeList)) {
                    this.setState({ localeValue: value, localeList });
                  }
                }}
                onBlur={(value) => {
                  if (this.isMouseEnterIcon) return;
                  localeList[locale] = value;
                  if (forceSync) { localeList = self.forceSyncChange(localeList, value); }
                  self.onBlur && self.onBlur(value, localeList);
                  if (!this.equalLang(localeList, this.state.localeList)) {
                    this.setState({ localeValue: value, localeList });
                  }
                }}
                onFocus={e => self.onFocus(e)}
                onClick={(e) => { e.stopPropagation(); }}
                ref={(input) => { this.textInput = input }}
              />
              {this.props.showIcon ? <div className="input-icon" onClick={disabled ? () => { } : this.open} onMouseEnter={this.onMouseEnterIcon} onMouseLeave={this.onMouseLeaveIcon}><SvgIcon type={"yingwen"} /> </div> : ''}
              {getFieldError(this.props.inputId) ? <span className='error uf uf-exc-t'>{getFieldError(this.props.inputId)}</span> : ''}
            </div>
          )
        }
        <ModalWrap title={modalLocale.title} showModal={this.state.showModal} backdrop={backdrop} cancelName={modalLocale.cancelName}
          onOk={this.onOk}
          onCancel={this.onCancel}
          okName={modalLocale.okName}
          close={this.onClose}
        >
          {this.getLocaleFormElement(_localeList, modalLocale, locale, sysLocale, getFieldProps, getFieldError)}
        </ModalWrap>
      </div>
    )
  }
  _renderPopconfirmRequireInputLocal() {
    const self = this;
    const { className, isTextarea, backdrop, disabled, forceSync, onChange, onBlur } = this.props
    let { localeValue, locale, localeList, _localeList, status, modalLocale, sysLocale, required, isPopConfirm } = this.state
    let defaultValue;
    if (localeList && localeList[sysLocale]) {
      defaultValue = localeList[sysLocale];
    }
    let formControlTypeOption = {}
    isTextarea ? formControlTypeOption = { componentClass: 'textarea' } : null
    let getFieldProps, getFieldError
    return (
      <div className={`ac-input-locale ${className ? className : null}`} >
        {
          status === 'preview' ? this.getPreviewElement(localeValue, defaultValue, localeList, modalLocale, locale) : (
            <div>
              <FormInputControl
                className="input-text"
                disabled={disabled}
                {...formControlTypeOption}
                {...getFieldProps(this.props.inputId, {
                  validateTrigger: 'onBlur',
                  rules: [{
                    validator: this.checkValidValue
                  }],
                  getValueProps: (value) => {
                    return {
                      value: localeValue
                    }
                  },
                  initialValue: localeValue,
                  onChange: (curValue) => {
                    this.onChange(curValue, localeList);
                  },
                  onBlur: (curValue) => {
                    Object.keys(localeList).forEach((localeKey) => {
                      if (localeKey === locale) {
                        localeList[localeKey] = curValue
                      }
                    })
                    if (forceSync) {
                      localeList = self.forceSyncChange(localeList, curValue);
                    }

                    self.onBlur && self.onBlur(localeList, curValue);
                    if (!this.equalLang(localeList, this.state.localeList)) {
                      this.setState({
                        localeValue: curValue,
                        localeList
                      })
                    }
                  }
                })}
                onClick={(e) => { e.stopPropagation() }}
                ref={(input) => { this.textInput = input }}
              />
              {/* <Popover
                  onClick = {disabled?()=>{}: this.open } 
                  trigger="click"
                  rootClose
                  placement="right"
                  secondPlacement="bottom"
                  className="ac-input-locale-popconfirm"
                  onClose={this.onOk}
                  onCancel={this.close}
                //   show={this.state.showPop}
                  // onClick={this.open}
                //   onRootClose={this.close}
                  content={this.getLocaleFormElement(localeList, modalLocale, locale, sysLocale,getFieldProps, getFieldError)}
                >
                  {
                    this.props.showIcon?<div className="input-pop-icon uf uf-globe"></div>:<span></span>
                  }
      </Popover> */}
              <Popconfirm
                //   trigger="click"
                //   rootClose
                placement="right"
                okText={modalLocale.okName}
                cancelText={modalLocale.cancelName}
                //   defaultOverlayShown={false}
                //   secondPlacement="bottom"
                overlayClassName="ac-input-locale-popconfirm"
                onConfirm={this.onOk}
                onCancel={this.onClose}
                icon={""}
                visible={this.state.showPop}
                onClick={this.open}
                //   onRootClose={this.close}
                title={this.getLocaleFormElement(localeList, modalLocale, locale, sysLocale, getFieldProps, getFieldError)}
              >
                <div className="input-pop-icon">
                  <SvgIcon type={"yingwen"} />
                </div>
              </Popconfirm>
              {/* {
                  getFieldError(this.props.inputId)?<span className='error uf uf-exc-t'>
                  {getFieldError(this.props.inputId)}
                </span>:''
                } */}
            </div>
          )
        }
      </div>
    )
  }
  _renderPopconfirmInputLocal() {
    const self = this;
    const { className, isTextarea, backdrop, disabled, forceSync, onChange, onBlur } = this.props
    let { localeValue, locale, localeList, status, modalLocale, sysLocale, required, isPopConfirm } = this.state
    let defaultValue;
    if (localeList && localeList[sysLocale]) {
      defaultValue = localeList[sysLocale];
    }
    let formControlTypeOption = {}
    isTextarea ? formControlTypeOption = { componentClass: 'textarea' } : null
    let getFieldProps, getFieldError
    return (
      <div className={`ac-input-locale ${className ? className : null}`} >
        {
          status === 'preview' ? this.getPreviewElement(localeValue, defaultValue, localeList, modalLocale, locale) : (
            <div>
              <FormInputControl
                className="input-text"
                value={localeValue}
                {...formControlTypeOption}
                onChange={(value) => {
                  // Object.keys(localeList).forEach((localeKey) => {
                  //   if (localeKey === locale) {
                  //     localeList[localeKey] = value
                  //   }
                  // })
                  localeList[locale] = value;
                  if (forceSync) localeList = self.forceSyncChange(localeList, value);
                  onChange && onChange(value, localeList);

                  this.setState({ localeValue: value, localeList });
                }}

                onBlur={(value) => {
                  localeList[locale] = value;

                  if (forceSync) { localeList = self.forceSyncChange(localeList, value); }
                  self.onBlur && self.onBlur(value, localeList);


                  if (!this.equalLang(localeList, this.state.localeList)) {
                    this.setState({ localeValue: value, localeList });
                  }
                }}

                onClick={(e) => { e.stopPropagation() }}
                ref={(input) => { this.textInput = input }}
              />
              <Popconfirm
                //   trigger="click"
                //   rootClose
                // placement="left"
                okText={modalLocale.okName}
                cancelText={modalLocale.cancelName}
                //   defaultOverlayShown={false}
                //   secondPlacement="bottom"
                overlayClassName="ac-input-locale-popconfirm"
                onConfirm={this.onOk}
                onCancel={this.onClose}
                icon={""}
                visible={this.state.showPop}
                onClick={this.open}
                //   onRootClose={this.close}
                title={this.getLocaleNoFormElement(localeList, modalLocale, locale)}
              >
                <div className="input-pop-icon">
                  <SvgIcon type={"yingwen"} />
                </div>
              </Popconfirm>
            </div>
          )
        }
      </div>
    )
  }

  render() {
    let { required, isPopConfirm } = this.state;
    if (required) {
      if (isPopConfirm) {
        return this._renderPopconfirmRequireInputLocal();//pop
      } else {
        return this._renderModalRequireInputLocal();//modal
      }
    } else {
      if (isPopConfirm) {
        return this._renderPopconfirmInputLocal();//pop
      } else {
        return this._renderModalInputLocal();//modal
      }
    }
  }
}

AcInputLocale.propTypes = propTypes;
AcInputLocale.defaultProps = defaultProps;
AcInputLocale = Form.create({})(AcInputLocale);
export default AcInputLocale;
